import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import type { TokenStatus } from "src/app/shared/components/token-input/token-input.component";
import { MDBModalRef } from "ng-uikit-pro-standard";
import {
  showError,
  showSucess,
} from "src/app/shared/utils/functions/notification.function";

import { IUsuarioEmpresa } from "../../models/perfil.model";
import { CognitoService } from "src/app/shared/services/cognito.service";
import { PerfilService } from "../../services/perfil.service";

@Component({
  selector: "app-modal-validate-token",
  templateUrl: "./modal-validate-token.component.html",
  styleUrls: ["./modal-validate-token.component.scss"],
})
export class ModalValidateTokenComponent implements OnInit {
  mdbRef: MDBModalRef;

  formToken: FormGroup;
  tokenForm: string = "";
  username?: string;
  modo: 'login' | 'perfil' = 'login';

  model: IUsuarioEmpresa;
  emailVerified: boolean;
  emailMascarado: string = "";

  tokenStatus: TokenStatus = "idle";
  validating = false;

  constructor(
    public modalRef: MDBModalRef,
    private cognitoService: CognitoService,
    private perfilService: PerfilService
  ) {}

  ngOnInit(): void {
    this.createFormToken(this.tokenForm);

    if (this.modo === 'perfil') {
      if(this.model && this.model.email) {
        this.cognitoService.updateUserEmail(this.model.email).subscribe(
          (res) => {
            this.emailMascarado = this.model.email;
          },
          e => {
            this.close();
            if (e.message === "User is already confirmed") {
              return showError("", "Usuário já está confirmado.");
            }
            return showError("", e.message);
          }
        );
      } else {
        this.close();
        return showError("", "Email do usuário não encontrado. Tente novamente mais tarde.");
      }
    }

    if (this.modo === 'login' && this.username) {
      this.cognitoService.resendEmailCodePublic(this.username).subscribe(
        (res) => {
          const parsedResp = typeof res === 'string' ? JSON.parse(res) : res;

          if (parsedResp && parsedResp.CodeDeliveryDetails) {
            this.emailMascarado = parsedResp.CodeDeliveryDetails.Destination;
          }
        }
      );
    }
  }

  enviarTokenEmail() {
    if (this.modo === 'login') {
      this.cognitoService.resendEmailCodePublic(this.username)
        .subscribe(
          () => showSucess(
            "Sua solicitação foi recebida com sucesso.",
            "Um novo token foi enviado para o email informado."
          ),
          (e) => showError("", e.message)
        );
    } else {
      this.cognitoService.updateUserEmail(this.model.email)
        .subscribe(
          () => showSucess(
            "Sua solicitação foi recebida com sucesso.",
            "Um novo token foi enviado para o email informado."
          ),
          (e) => showError("", e.message)
        );
    }
  }

  validateEmail() {
    if (this.formToken.invalid) {
      this.tokenStatus = "error";
      return;
    }

    this.validating = true;
    this.tokenStatus = "idle";

    if (this.modo === 'login') {
      this.cognitoService.confirmEmailPublic(this.username, this.tokenFornecido.value)
        .subscribe(() => {
          this.validating = false;
          this.tokenStatus = "success";
          setTimeout(() => {
            showSucess(
              "Sua solicitação foi recebida com sucesso.",
              "Agora você pode acessar sua conta."
            );
            this.close();
          }, 800);
        }, e => {
          this.validating = false;

          if (this.tokenError(e)) {
            this.tokenStatus = "error";
          } else {
            this.tokenStatus = "idle";
            showError("", e.message);
          }
        });
    } else {
      this.cognitoService.verifyNewEmail(this.tokenFornecido.value)
      .subscribe(
        () => {
          this.validating = false;
          this.tokenStatus = "success";
          this.atualizaCognito()
        },
        (e) => {
          this.validating = false;

          if (this.tokenError(e)) {
            this.tokenStatus = "error";
          } else {
            this.tokenStatus = "idle";
            showError("", e.message);
          }
        }
      );
    }
  }

  atualizaCognito() {
    const cpf = this.model.documentoIdentificador;

    this.perfilService.confirmarUpdate(cpf).subscribe(
      () => {
        this.validating = false;
        setTimeout(() => {
          showSucess(
            "Sua solicitação foi recebida com sucesso.",
            "Dados para contato atualizados com sucesso."
          );
          this.close();
        }, 800);
      },
      (e) => showError("", e.message)
    );
  }

  createFormToken(token: string) {
    this.formToken = new FormGroup({
      token: new FormControl(token, [
        Validators.required,
        Validators.minLength(6),
      ]),
    });
  }

  private tokenError(e: any): boolean {
    const codigo = e?.code || e?.name || '';
    return [
      "CodeMismatchException",
      "ExpiredCodeException",
    ].includes(codigo);
  }

  get tokenFornecido() {
    return this.formToken.get("token");
  }

  close() {
    return this.modalRef.hide();
  }
}
